module.exports = __webpack_public_path__ + "static/media/hourglass_gold_full5cdae1645325ffd782693392c23ef3d7.webp";